import * as React from 'react';

export const Data = React.createContext([]);
